// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"5fb16bdd","455":"5fb16bdd","742":"9b8c39b5"}[chunkId] + ".chunk.css";
};